import script from "./ConnectionGame.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectionGame.vue?vue&type=script&setup=true&lang=js"

import "./ConnectionGame.vue?vue&type=style&index=0&id=0689362e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0689362e"]])

export default __exports__